import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="div-footer">
        <div className="footer-link-container">
          <a href="https://github.com/ammusto/sham-scrap">
            <img id="git_footer" src="/media/github-mark.png" alt="GitHub" />
          </a>
        </div>
        <div>
          © Antonio Musto {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
